import {
    PDP_SELLER_MODULE_TEST_VARIANT_REVIEWS_PAGE_SIZE,
    DEFAULT_MOBILE_REVIEWS_PAGE_SIZE,
    DEFAULT_DESKTOP_REVIEWS_PAGE_SIZE,
} from './constants.ts';

export const getReviewsPageSize = (
    isPdpSellerModuleTestVariant: boolean,
    isMobileScrollContainer: boolean
): number => {
    if (isPdpSellerModuleTestVariant) {
        return PDP_SELLER_MODULE_TEST_VARIANT_REVIEWS_PAGE_SIZE;
    }

    return isMobileScrollContainer
        ? DEFAULT_MOBILE_REVIEWS_PAGE_SIZE
        : DEFAULT_DESKTOP_REVIEWS_PAGE_SIZE;
};
